import { CheckboxField } from "@aws-amplify/ui-react";

const SubscriptionCheckBox = ({
  subscriptionStatus,
  triggerType,
  type,
  handleCheckboxChange,
}) => {
  const status = subscriptionStatus.find(
    (subscription) => subscription.triggerType === triggerType
  );
  const checked = status ? status[`subscribe${type}`] ?? false : false;
  const isDisabled = status ? status[`subscribe${type}`] == null : true;

  return (
    <CheckboxField
      checked={checked}
      isDisabled={isDisabled}
      onChange={(event) => handleCheckboxChange(event, triggerType, type)}
    />
  );
};

export default SubscriptionCheckBox;